import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import moment from "moment";
import locale from "antd/es/date-picker/locale/zh_TW";
import { useDispatch, useSelector } from "react-redux";
import { financeOrderState, setOrderListFilter } from "@redux/financeOrderSlice";
import { ContractType } from "@api/financeOrderApi";
import throughShipmentApi, { RetailList } from "@api/throughShipment/throughShipmentApi";

const Wrapper = styled(Form)`
  padding: 20px;
`;
const CustomRangePicker = styled(DatePicker.RangePicker)`
  width: 100%;
`;
const CustomButton = styled(Button)`
  margin-right: 10px;
`;

const { Option } = Select;

export default function Filter() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { orderListFilter } = useSelector(financeOrderState);
  const [retailListResult, setRetailListResult] = useState<RetailList[]>([]);

  const contractTypeValue = Form.useWatch("contractType", form);

  const fetchRetailers = async (contractType: number) => {
    try {
      const response = await throughShipmentApi.fetchRetailList({
        contractTypes: [contractType],
      });
      setRetailListResult(response.results);
    } catch (error) {
      setRetailListResult([]);
    }
  };

  useEffect(() => {
    form.setFieldsValue({ retailerId: undefined });
    if (contractTypeValue) fetchRetailers(contractTypeValue);
  }, [contractTypeValue, form]);

  const clearFilter = () => {
    form.resetFields();
    dispatch(
      setOrderListFilter({
        limit: orderListFilter.limit,
        offset: 0,
      }),
    );
  };

  const onSubmit = (values: any) => {
    dispatch(
      setOrderListFilter({
        ...orderListFilter,
        sku: values.sku,
        contractType: values.contractType,
        retailerId: values.retailerId,
        accountDateAfter: values.accountDate ? moment(values.accountDate[0]).format("YYYY-MM-DD") : undefined,
        accountDateBefore: values.accountDate ? moment(values.accountDate[1]).format("YYYY-MM-DD") : undefined,
        invoiceNumber: values.invoiceNumber,
      }),
    );
  };

  return (
    <Wrapper colon={false} labelAlign="left" form={form} initialValues={{}} onFinish={onSubmit} labelCol={{ span: 6 }}>
      <Row gutter={[12, 4]}>
        <Col span={8}>
          <Form.Item label="類型" name="contractType">
            <Select placeholder="請選擇">
              <Option value={ContractType.CONSIGNMENT}>寄倉</Option>
              <Option value={ContractType.TRANSFER}>轉單</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="供應/經銷商" name="retailerId">
            <Select placeholder="請先選擇類型" disabled={!contractTypeValue} allowClear>
              {retailListResult.map((retailer) => {
                return (
                  <Option key={retailer.id} value={retailer.id}>
                    {retailer.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="SKU(品號)" name="sku">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 4]}>
        <Col span={8}>
          <Form.Item label="發票日期" name="accountDate">
            <CustomRangePicker locale={locale} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="發票號碼" name="invoiceNumber">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={30} justify="end">
        <Col>
          <Row>
            <CustomButton onClick={clearFilter}>清除篩選條件</CustomButton>
            <Button type="primary" htmlType="submit">
              套用
            </Button>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
}
